import { render, staticRenderFns } from "./EvaluationTab.vue?vue&type=template&id=64182784&"
import script from "./EvaluationTab.vue?vue&type=script&lang=js&"
export * from "./EvaluationTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports